import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import PageHeader from "./common/PageHeader";
import { Link } from "react-router-dom";

const TermsOfUse = () => {
  return (
    <>
      <br />
      <Container className="my-5">
        <PageHeader
          title="Terms of Use for CONDOZAK™"
          description="Last Updated: March 01, 2025"
          className="mb-3"
          titleTag="h2"
        >
          
          <Link className="btn btn-sm btn-link ps-0" to="/contact-us">
            Have questions? Chat with us
          </Link>
        </PageHeader>
        <Row className="justify-content-center">
          <Col md={12}>
            <Card>
              <Card.Body>
                <h5>1. Acceptance of Terms</h5>
                <p>
                  By accessing and using CONDOZAK™, a property management
                  software provided by Truzak Technology Inc. ("Truzak", "we",
                  "our", "us"), you agree to comply with and be bound by these
                  Terms of Use ("Terms"). If you do not agree with these Terms,
                  you should not access or use CONDOZAK™.
                </p>

                <h5>2. Description of Services</h5>
                <p>
                  CONDOZAK™ is a Software-as-a-Service ("SaaS") platform
                  designed for property management companies, board members,
                  unit owners, and residents. It provides functionalities
                  including administration, record-keeping, communications, and
                  a resident portal. CONDOZAK™ is hosted on the cloud, allowing
                  access through supported web browsers.
                </p>

                <h5>3. Registration and Account Security</h5>
                <p>
                  You are responsible for maintaining the confidentiality of
                  your login credentials. You agree to notify us immediately of
                  any unauthorized access or breach of security. You must
                  provide accurate, complete information during account
                  registration and keep such information updated.
                </p>

                <h5>4. Use of the Platform</h5>
                <ul>
                  <li>
                    Engage in illegal activities or violate any applicable laws
                    or regulations.
                  </li>
                  <li>
                    Attempt unauthorized access, interference, or disruption of
                    the platform.
                  </li>
                  <li>Share or distribute your login credentials.</li>
                  <li>
                    Copy, modify, reverse-engineer, or attempt to discover the
                    source code of the software.
                  </li>
                </ul>

                <h5>5. User Content</h5>
                <p>
                  You retain ownership rights in the data you upload to
                  CONDOZAK™. By submitting data, you grant us a non-exclusive,
                  royalty-free license to use, store, display, and distribute
                  this data solely for the purpose of providing and improving
                  our services.
                </p>

                <h5>6. Privacy and Data Security</h5>
                <p>
                  Our Privacy Policy, available on our website, outlines our
                  practices concerning the collection, use, and protection of
                  your personal information. You agree to our use of your data
                  as described in our Privacy Policy.
                </p>

                <h5>7. Intellectual Property</h5>
                <p>
                  All intellectual property rights related to CONDOZAK™,
                  including trademarks, copyrights, trade secrets, and
                  proprietary software, are owned by Truzak Technology Inc.
                </p>

                <h5>8. Termination</h5>
                <p>
                  We reserve the right to terminate or suspend your account
                  immediately, without prior notice, if you breach these Terms
                  or engage in activity harmful to us or other users.
                </p>

                <h5>9. Disclaimer of Warranties</h5>
                <p>
                  CONDOZAK™ is provided on an "as-is" and "as-available" basis.
                  We make no warranties or guarantees, express or implied,
                  regarding the accuracy, reliability, or completeness of our
                  software.
                </p>

                <h5>10. Limitation of Liability</h5>
                <p>
                  To the maximum extent permitted by law, Truzak shall not be
                  liable for any indirect, incidental, consequential, or
                  punitive damages arising from your use of or inability to use
                  CONDOZAK™.
                </p>

                <h5>11. Modifications to Terms</h5>
                <p>
                  We may revise these Terms periodically. Any changes will be
                  posted to our website with an updated "Last Updated" date.
                  Continued use of CONDOZAK™ following such changes constitutes
                  your acceptance of the revised Terms.
                </p>

                <h5>12. Governing Law and Jurisdiction</h5>
                <p>
                  These Terms shall be governed by and interpreted in accordance
                  with the laws of the Province of Ontario, Canada.
                </p>

                <h5>13. Contact Information</h5>
                <p>
                  For questions or comments regarding these Terms, please
                  contact us at:
                </p>
                <address>
                  {/* Truzak Technology Inc.
                  <br />
                  180 Northfield Drive West, Suite 4<br />
                  Waterloo, Ontario, N2L 0C7, Canada
                  <br /> */}
                  Email: <a href="mailto:info@condozak.ca">info@condozak.ca</a>
                </address>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default TermsOfUse;
